import type { AiAppCenterModule } from '../types'

export const houseModule: AiAppCenterModule = {
  key: 'house',
  label: '找房源系统',
  desc: '用户找房 · 业主发布 · 中介受托 · 委托撮合 · 项目-楼栋-房源数据域',
  path: '/house',
  homePath: '/house/category',
  icon: 'ep:house',
  color: '#2B6DE5'
}
